"use client";

import { usePathname } from "next/navigation";
import Link from "next/link";

import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbSeparator,
} from "@/components/ui/breadcrumb";

import tools from "@/static/tools.json";

export const Header = () => {
  const pathname = usePathname();

  if (pathname === "/ferramentas") return null;

  return (
    <>
      <Breadcrumb>
        <BreadcrumbList>
          <BreadcrumbItem>
            <BreadcrumbLink asChild>
              <Link prefetch={false} href="/">
                Início
              </Link>
            </BreadcrumbLink>
          </BreadcrumbItem>
          <BreadcrumbSeparator />
          <BreadcrumbItem>
            <BreadcrumbLink asChild>
              <Link prefetch={false} href="/ferramentas">
                Ferramentas gratuitas
              </Link>
            </BreadcrumbLink>
          </BreadcrumbItem>
        </BreadcrumbList>
      </Breadcrumb>
      <div className="flex flex-col gap-3 items-center justify-center">
        <h1 className="text-center text-4xl font-bold">
          {/* @ts-ignore */}
          {tools[pathname].name}
        </h1>
        <h2 className="text-center text-base text-muted-foreground w-full sm:w-[1024px]">
          {/* @ts-ignore */}
          {tools[pathname].description}
        </h2>
      </div>
    </>
  );
};
